import { NewSiteInterface } from '@shared/api';
import { Observable } from 'rxjs';

export interface AddSiteModalDataInterface {
  addSite: (value: NewSiteInterface) => Observable<unknown>;
}

export const KEEN_DNS_PATTERN =
  '^\\s*((http|https)\\:\\/\\/)?[a-zA-Z0-9\\.\\/\\?\\:@\\-_=#]+\\.([a-zA-Z0-9\\&\\.\\/\\?\\:@\\-_=#]){1,}\\s*';

export const SERVICE_CODE_PATTERN = '^(\\d{3}[-]){4}\\d{3}$';
